import { simpleLookupManagementConfig } from "../../../../records/lookup/utils/simpleLookupManagementConfig";
import { vsLookupManagementServiceProviderName } from "./lookupManagement";

export const vsObjectName = "gamingContractFeeStructureType";

const url = "api/contract/gamingContract/feeStructureType";

export const FeeStructureConfig = simpleLookupManagementConfig({
  lookupEditPermission: "contractLookupModify",
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
  nameSingular: "Fee Structure",
  objectName: vsObjectName,
  url,
});
